module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.isDashboard) ? _c('div', {
    staticClass: "right"
  }, [_vm._v("技术支持：浙江甲骨文科技集团")]) : _c('div', {
    staticClass: "right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eba38006!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chayeheader/index.vue
// module id = 2105
// module chunks = 2